var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInquiryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inquiry"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000001874"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.335 11.25V6.87503C19.335 5.8395 18.4955 5.00003 17.46 5.00003H6.45996C5.42443 5.00003 4.58496 5.8395 4.58496 6.87503V14.375C4.58496 15.4106 5.42443 16.25 6.45996 16.25C7.18484 16.25 7.77246 16.8377 7.77246 17.5625V18.6252C7.77246 18.9595 8.17674 19.127 8.41318 18.8906L10.2004 17.1033C10.7468 16.557 11.4878 16.25 12.2605 16.25H17.46C18.4955 16.25 19.335 15.4106 19.335 14.375",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000001833"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.1299 8.95618C10.2775 8.53661 10.5688 8.18282 10.9523 7.95746C11.3357 7.73211 11.7865 7.64973 12.2249 7.72492C12.6633 7.80011 13.0609 8.02802 13.3473 8.36828C13.6338 8.70854 13.7905 9.13919 13.7899 9.58395C13.7899 10.8395 11.9065 11.4673 11.9065 11.4673V12.4762",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.9561 13.7631H11.9644",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInquiryIcon);
export default __webpack_public_path__ + "static/media/InquiryIcon.6a48831e727bda5bc9281a1f98ecb00e.svg";
export { ForwardRef as ReactComponent };